import React, { Component } from 'react';
import { Typography } from '@material-ui/core';

type Props = {
    label: string,
    quantity: number
}

class ChipLabel extends Component<Props>{
    render() {
        return (
            <div>
                <div style={{ display: "inline-block" }}>
                    <Typography variant="inherit">{this.props.label}</Typography>
                </div>
                <div style={{ display: "inline-block" }}>
                    <Typography style={{color: '#fff'}} variant="h4">&nbsp;&nbsp;{this.props.quantity}</Typography>
                </div></div>
        )
    }
}

export default ChipLabel;